module.exports = __webpack_public_path__ + "static/media/filerequest.d4993d40.svg";